var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useState, useEffect } from "react";
import { useTheme } from "styled-components";
import { HeadlineWithShortTeaserContainer } from "./HeadlineWithShortTeaser.styles";
import { TransparentLayer, StyledParagraph, StyledTypo, StyledLink, BorderLayer, } from "../common/Common.styles";
export function Tlea2(_a) {
    var { title, subTitle, size, paragraph, link: { target, text, hasArrow = true, onClick, windowTarget = "self" }, backgroundType, customBackground, children, emphasize = "title", fontSize = "p2", gap, titlePreviewId = "#st_title" } = _a, rest = __rest(_a, ["title", "subTitle", "size", "paragraph", "link", "backgroundType", "customBackground", "children", "emphasize", "fontSize", "gap", "titlePreviewId"]);
    const theme = useTheme();
    const [focused, setFocused] = useState(false);
    const [height, setHeight] = useState(0);
    const tileRef = useRef(null);
    useEffect(() => {
        function setWidth() {
            if (tileRef.current === null)
                return;
            const tileWidth = Number(window.getComputedStyle(tileRef.current).width.replace("px", ""));
            setHeight(tileWidth);
        }
        setWidth();
        window.addEventListener("resize", setWidth);
        return () => window.removeEventListener("resize", setWidth); // cannot test unmount
    }, []);
    function renderHeadline() {
        return (_jsxs(_Fragment, { children: [_jsx(StyledTypo, Object.assign({ backgroundtype: backgroundType, variant: "h3", fontWeight: emphasize === "title"
                        ? theme.fontWeights.medium
                        : theme.fontWeights.light, isUppercase: true }, { children: _jsxs(_Fragment, { children: [rest.previewId && rest.isPreview ? (_jsx("span", Object.assign({ "data-preview-id": titlePreviewId }, { children: title }))) : (title), _jsx(StyledTypo, Object.assign({ backgroundtype: backgroundType, tag: "span", size: {
                                    xsmall: theme.fontTokens.font07,
                                    medium: theme.fontTokens.font06,
                                    large: theme.fontTokens.font05,
                                    xlarge: theme.fontTokens.font04,
                                }, fontWeight: emphasize === "subTitle"
                                    ? theme.fontWeights.medium
                                    : theme.fontWeights.light, isUppercase: true }, { children: rest.previewId && rest.isPreview ? (_jsx("span", Object.assign({ "data-preview-id": "#st_subtitle" }, { children: subTitle }))) : (subTitle) }))] }) })), _jsx(StyledParagraph, Object.assign({ backgroundtype: backgroundType, fontSize: fontSize }, { children: rest.previewId && rest.isPreview ? (_jsx("span", Object.assign({ "data-preview-id": "#st_text" }, { children: paragraph }))) : (paragraph) })), target && text && (_jsx(StyledLink, { fontSize: fontSize, hasArrow: hasArrow, onClick: (e) => {
                        if (typeof onClick === "function") {
                            onClick(e);
                        }
                    }, windowTarget: windowTarget, stylingType: backgroundType === "light"
                        ? "secondary"
                        : backgroundType === "dark"
                            ? "invertedOnColor"
                            : "inverted", text: text, target: target, alignByContent: "left" }))] }));
    }
    return (_jsxs(HeadlineWithShortTeaserContainer, Object.assign({ ref: tileRef, gap: gap, height: height, onMouseDown: () => setFocused(false), onKeyUp: () => setFocused(true), onBlur: () => setFocused(false), focused: focused, tabIndex: 0, backgroundType: backgroundType, customBackground: customBackground, size: size, "data-testid": "headline-with-short-teaser-input" }, rest, { children: [_jsx(TransparentLayer, { className: "gdds-transparent-layer" }), children || renderHeadline(), _jsx(BorderLayer, { className: "gdds-border-layer" })] })));
}
